<template>
  <a-spin :spinning="loading">
    <div class="mindmap-container">
      <Toolbar />
      <Edit ref="editRef" :org-data="caseTreeData" @save="onSave" />
    </div>
  </a-spin>
</template>

<script>
import Toolbar from '@/components/Mind/components/Toolbar';
import Edit from '@/components/Mind/components/Edit';
import '@/components/Mind/assets/icon-font/iconfont.css';
import { caseList, moduleList, mindSaveCase } from '@/api/project/case';
import { buildSaveNodes, getNodeType } from './saveUtils';
export default {
  components: {
    Toolbar,
    Edit
  },
  data() {
    return {
      key: 0,
      moduleCases: [],
      loading: false,
      moduleData: [],
      caseDataList: [],
      caseTreeData: {
        name: '根节点'
      }
    };
  },
  mounted() {
    // this.getModuleList();
  },
  methods: {
    onSave(data, startData, callBack) {
      this.utils.trackClick({ name: '保存脑图' });
      var nodes = [];
      data = JSON.parse(JSON.stringify(data));
      // console.log('data', data);
      if (data.children && data.children.length > 0) {
        for (let index = 0; index < data.children.length; index++) {
          const element = data.children[index];
          const tag = getNodeType(element);
          if (tag !== '用例') {
            this.$message.warning('目前仅支持单层级模块用例的保存');
            return;
          }
        }
      }
      startData = JSON.parse(JSON.stringify(startData));
      const _data = buildSaveNodes(startData, data, nodes);
      console.log('_data', _data);
      const _params = {
        project_id: parseInt(this.$route.params.project_id) || null,
        added_nodes: _data.addedNodes,
        changed_nodes: _data.changedNodes,
        deleted_nodes: _data.deletedNodes
      };
      callBack(true);
      mindSaveCase(_params)
        .then(res => {
          this.$message.success('保存用例成功');
          this.$emit('saveOK');
        })
        .finally(() => {
          callBack(false);
        });
    },
    initModule(nodeModuleData) {
      this.caseTreeData = nodeModuleData;
      this.getCaseList();
    },
    buildCaseToModule(treeData, cases) {
      if (!treeData) return;
      if (!treeData.children) treeData.children = [];
      treeData.children.forEach(c => {
        this.buildCaseToModule(c, cases);
      });
      const childrenCases = cases.filter(c => c.module_id === treeData.id);
      treeData.children.push(...childrenCases);
    },
    // 获取用例列表
    async getCaseList() {
      this.loading = true;
      let _module_id = -1;
      let _project_id = -1;
      if (this.caseTreeData) {
        _module_id = this.caseTreeData.id || -1;
        _project_id = this.caseTreeData.project_id || -1;
      }

      const { code, message, data } = await caseList({ project_id: _project_id, module_id: _module_id, page_size: 10000, page_number: 1 });
      if (code === 2000) {
        this.caseDataList = data.items;
        this.buildCaseToModule(this.caseTreeData, this.caseDataList);
        // this.key++;
        this.$nextTick(() => {
          this.$refs.editRef.changeData(this.caseTreeData);
        });
      } else {
        console.error(message);
      }
      this.loading = false;
    },
    getModuleList() {
      moduleList({ project_id: 5 })
        .then(res => {
          this.moduleCases = res.data.module_cases;
          const items = JSON.parse(JSON.stringify(res.data.items));
          const children = [
            {
              id: 0,
              key: 0,
              title: '未分配',
              name: '未分配',
              total: this.moduleCases[null] || 0,
              scopedSlots: { title: 'title' },
              children: []
            },
            ...this.listToTree(items)
          ];
          const trashedChildren = [
            {
              id: -3,
              key: -3,
              title: '未分配',
              name: '未分配',
              total: this.moduleCases['null-trashed'] || 0,
              scopedSlots: { title: 'title' },
              children: []
            },
            ...this.listToTree(res.data.items, 0, true)
          ];
          const total = children.reduce((sum, c) => sum + (c.total || 0), 0);
          const trashedTotal = trashedChildren.reduce((sum, c) => sum + (c.total || 0), 0);
          this.moduleData = [
            {
              id: -1,
              key: -1,
              title: '正常用例',
              name: '正常用例',
              total: total,
              scopedSlots: { title: 'title' },
              children: children
            },
            {
              id: -2,
              key: -2,
              title: '已废弃',
              name: '已废弃',
              total: trashedTotal,
              scopedSlots: { title: 'title' },
              children: trashedChildren
            }
          ];

          console.log('this.moduleData', this.moduleData);
          this.caseTreeData = this.moduleData[0];
          this.getCaseList();
          // this.key++;
        })
        .catch(() => {});
    },
    listToTree(list, parentId = 0, trashed = false) {
      const menuObj = {};
      const tempArr = [];
      list.forEach(item => {
        let total = this.moduleCases[item.id] || 0;
        if (trashed) {
          total = this.moduleCases[item.id + '-trashed'] || 0;
        }
        const temp = { ...item, total: total, scopedSlots: { title: 'title' }, children: [] };
        tempArr.push(temp);
        menuObj[item.id] = temp;
      });
      let treeData = tempArr.filter(item => {
        if (item.parent_id !== parentId) {
          let father = menuObj[item.parent_id];
          // 父目录被删除，子目录不展示
          if (!father) {
            return false;
          }
          father.children.push(item);
          let total = this.moduleCases[item.id] || 0;
          if (trashed) {
            total = this.moduleCases[item.id + '-trashed'] || 0;
            item.key = 0 - item.key;
          }

          father.total += total;
          if (trashed && father.key > 0) {
            father.key = 0 - father.key;
          }
          // 深度搜索
          while (father.parent_id !== parentId) {
            father = menuObj[father.parent_id];
            if (!father) {
              break;
            }
            total = this.moduleCases[item.id] || 0;
            if (trashed) {
              total = this.moduleCases[item.id + '-trashed'] || 0;
            }
            father.total += total;
            if (trashed && father.key > 0) {
              father.key = 0 - father.key;
            }
          }
          return false;
        }
        return true;
      });
      if (trashed) {
        treeData = treeData.filter(item => {
          this.clearTreeNodeChildren(item);
          return item.total > 0;
        });
      }
      return treeData;
    },
    clearTreeNodeChildren(node) {
      const children = node.children;
      if (children) {
        node.children = node.children.filter(c => c.total > 0);
        for (let i = 0; i < node.children.length; i++) {
          this.clearTreeNodeChildren(node.children[i]);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
#mindMapContainer * {
  margin: 0;
  padding: 0;
}

/* 添加样式确保思维导图正常显示 */
.mindmap-container {
  position: relative;
  width: 100%;
  height: calc(~'100vh - 175px');
}
</style>
